import { useContext } from 'react';

import { ServicesContext } from '@app/contexts/ServicesContext';

export function useServices() {
  return useContext(ServicesContext);
}
